import css from './LandingTemplatesSection.module.css';
import { LandingDIYTemplatesData } from '@modules/Landing/Shared/MockData/LandingDIYTemplatesData';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';
import { ViewAllTemplatesPreview } from '@modules/Landing/Shared/Ui/ViewAllTemplatesPreview/ViewAllTemplatesPreview';
import TemplateCard from '@shared/Widgets/TemplateCard/TemplateCard';
import { TemplateCategoryEnum } from '@shared/Enums/TemplateCategoryEnum';
import MobileCarousel from '@shared/Ui/MobileCarousel/MobileCarousel';

export const LandingTemplatesSection: React.FC = () => {
    const { landingTemplatesInitialization } = useTemplatesViewModel();

    const templatesList = landingTemplatesInitialization(
        LandingDIYTemplatesData
    ).map((landingTemplate, index) => (
        <TemplateCard
            key={index}
            template={landingTemplate}
            isLandingExample={true}
            category={TemplateCategoryEnum.DIY}
            extraCardContentClassName={css.cardContent}
            extraTemplateTitleClassName={css.templateTitle}
            extraImgClassName={css.cardImg}
            extraTemplateInfoClassName={css.templateInfo}
            extraCardDescriptionClassName={css.cardDescription}
            extraTemplateInfoPlaceholderBlockClassName={
                css.templateInfoPlaceholder
            }
        />
    ));

    return (
        <section className={css.section}>
            <div className={css.title}>Templates</div>
            <ViewAllTemplatesPreview />
            <MobileCarousel
                items={templatesList}
                extraItemClassName={css.templateCard}
            />
        </section>
    );
};
